module.exports = {
    //Common Button
    "GRD_BTN_SEARCH": "ค้นหา",
    "GRD_BTN_CLEAR": "ล้างข้อมูล",
    "GRD_BTN_ADD": "เพิ่ม",

    "GRD_ACTIVE": "ใช้งาน",
    "GRD_INACTIVE": "ไม่ใช้งาน",
}
